import { render, staticRenderFns } from "./ModalEditNote.vue?vue&type=template&id=67c5e7fa"
import script from "./ModalEditNote.vue?vue&type=script&lang=js"
export * from "./ModalEditNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports